export interface RevenueScenario {
  scenario: number;
  available: number;
  price: string;
  signups: number;
  availabilityPercent: string;
  oneTimeFee: string;
  revenue: string;
  siteShare: string;
  resellerShare: string;
  annualShare: string;
}

export interface RevenueSplit {
  monthlyGross: string;
  siteSplit: string;
  resellerSplit: string;
}

export const scenarios: RevenueScenario[] = [
  { 
    scenario: 1, 
    available: 300, 
    price: "$39.00",
    signups: 50, 
    availabilityPercent: "16.67%", 
    oneTimeFee: "$500", 
    revenue: "$1,950.00",
    siteShare: "$1,560.00", 
    resellerShare: "$390.00",
    annualShare: "$4,180.00"
  },
  { 
    scenario: 2, 
    available: 300, 
    price: "$39.00", 
    signups: 75, 
    availabilityPercent: "25.00%", 
    oneTimeFee: "$500", 
    revenue: "$2,925.00", 
    siteShare: "$2,340.00", 
    resellerShare: "$585.00",
    annualShare: "$6,020.00"
  },
  { 
    scenario: 3, 
    available: 300, 
    price: "$39.00", 
    signups: 100, 
    availabilityPercent: "33.33%", 
    oneTimeFee: "$500", 
    revenue: "$3,900.00", 
    siteShare: "$2,925.00", 
    resellerShare: "$975.00",
    annualShare: "$11,200.00"
  },
  { 
    scenario: 4, 
    available: 300, 
    price: "$49.00", 
    signups: 200, 
    availabilityPercent: "66.67%", 
    oneTimeFee: "$500", 
    revenue: "$9,800.00", 
    siteShare: "$7,840.00", 
    resellerShare: "$1,960.00",
    annualShare: "$23,020.00"
  },
  { 
    scenario: 5, 
    available: 600, 
    price: "$49.00", 
    signups: 450, 
    availabilityPercent: "75.00%", 
    oneTimeFee: "$1000", 
    revenue: "$22,050.00", 
    siteShare: "$17,640.00", 
    resellerShare: "$4,410.00",
    annualShare: "$51,920.00"
  },
  { 
    scenario: 6, 
    available: 1000, 
    price: "$59.00", 
    signups: 850, 
    availabilityPercent: "85.00%", 
    oneTimeFee: "$2000", 
    revenue: "$50,150.00", 
    siteShare: "$30,090.00", 
    resellerShare: "$20,060.00",
    annualShare: "$238,720.00"
  },
  { 
    scenario: 7, 
    available: 2000, 
    price: "$59.00", 
    signups: 1800, 
    availabilityPercent: "90.00%", 
    oneTimeFee: "$3500", 
    revenue: "$106,200.00", 
    siteShare: "$63,720.00", 
    resellerShare: "$42,480.00",
    annualShare: "$506,260.00"
  }
];

export const revenueSplits: RevenueSplit[] = [
  { monthlyGross: "$0 - $4,999", siteSplit: "80%", resellerSplit: "20%" },
  { monthlyGross: "$5,000 - $9,999", siteSplit: "75%", resellerSplit: "25%" },
  { monthlyGross: "$10,000 - $24,999", siteSplit: "70%", resellerSplit: "30%" },
  { monthlyGross: "$25,000 - $49,999", siteSplit: "65%", resellerSplit: "35%" },
  { monthlyGross: "$50,000 - $99,999", siteSplit: "60%", resellerSplit: "40%" },
  { monthlyGross: "$100,000+", siteSplit: "55%", resellerSplit: "45%" },
];
